<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="10" lg="9" xl="8">
          <v-sheet class="neu-glow with-radius">
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col
                  cols="12"
                  md="6"
                  class="pa-0"
                  v-if="$vuetify.breakpoint.mdAndUp"
                >
                  <v-sheet height="100%" color="transparent">
                    <v-row
                      align="center"
                      justify="center"
                      class="fill-height ma-0"
                    >
                      <v-img
                        :src="stepDetail.img"
                        :lazy-src="stepDetail.img"
                      ></v-img>
                    </v-row>
                  </v-sheet>
                </v-col>
                <!-- 2 -->
                <v-col cols="12" md="6" class="px-5 pos-relative">
                  <v-sheet max-width="400" class="px-8 my-6 pa-3 white rounded-lg elevation-8">
                  <!--
                  <div class="mt-8 mb-6 d-flex justify-center">
                    <v-img class="mx-4 mb-6"
                      src="/static/logos/green_arrow.svg"
                      lazy-src="/static/logos/green_arrow.svg"
                      max-width = "115"
                      contain
                  ></v-img>
                    <div class="text-subtitle-1">{{$t(page+'.'+stepDetail.title) }}</div>
                    <div class="text-body-2">{{ $t(page+'.'+stepDetail.subtitle) }}</div>
                  </div>-->

                  <div class="my-4 text-center">
                    <div class="text-h4 d-flex justify-center pb-2">
                      <v-img
                        src="/static/logos/iBook2_logo.png"
                        lazy-src="/static/logos/iBook2_logo.png"
                        max-width = "150"
                        contain
                    ></v-img>
                    </div>
                 <div class="text-subtitle-1">{{$t(page+'.'+stepDetail.title) }}</div>
                    <div v-if="stepDetail.subtitle" class="text-body-2" v-html="$t(page+'.'+stepDetail.subtitle)"></div>
                  </div>




                  <v-stepper
                    v-model="recoveryStep"
                    class="transparent clear-shadow"
                  >
                    <v-stepper-header class="hide">
                      <v-stepper-step :complete="recoveryStep > 1" step="1"
                        >1</v-stepper-step
                      >
                      <v-stepper-step :complete="recoveryStep > 2" step="2"
                        >2</v-stepper-step
                      >
                      <v-stepper-step step="3">3</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                      <v-stepper-content step="1" class="pa-0 ">
                        <send-otp
                          @next="recoveryStep = 2"
                          v-if="recoveryStep === 1"
                        />
                      </v-stepper-content>

                      <v-stepper-content step="2" class="pa-0">
                        <verify-otp
                          @next="recoveryStep = 3"
                          @prev="recoveryStep = 1"
                          v-if="recoveryStep === 2"
                        />
                      </v-stepper-content>

                      <v-stepper-content step="3">
                        <reset-password
                          @complete="completeProcess()"
                          v-if="recoveryStep === 3"
                        />
                      </v-stepper-content>

                    </v-stepper-items>
                  </v-stepper>
                  <!--
                  <v-btn
                    icon
                    absolute
                    top
                    right
                    to="/auth/login"
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                  -->
                </v-sheet>
                </v-col>
              </v-row>
            </v-card-text>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbar" absolute top right color="success">
      <span>{{$t(page+'.Password Reset Successfully')}}</span>
      <v-icon dark>check_circle</v-icon>
    </v-snackbar>
  </v-sheet>
</template>

<script>
export default {
  components: {
    SendOtp: () => import("./Partials/SendOtp"),
    VerifyOtp: () => import("./Partials/VerifyOtp"),
    ResetPassword: () => import("./Partials/ResetPassword"),
  },
  data() {
    return {
      page:'Auth',
      snackbar: false,
      email:'',
      recoveryStep: 1,
      stepsDetails: [
        {
          title: "Recover Your Account",
          subtitle: "Enter your e-mail address to reset your password",
          img: "/static/ob-animated-isometric/forgot-password-animate.svg",
        },
        {
          title: "Enter 9-Digit Code",
          subtitle:
            "We sent a 9-digit code to your email address: check also among SPAM folder and Enter code below.",
          img: "/static/ob-animated-isometric/enter-otp-animate.svg",
        },
        {
          title: "Set New Password",
          subtitle: null,
          img: "/static/ob-animated-isometric/my-password-animate.svg",
        },
      ],
    };
  },
  created(){
    document.title = 'iBookRestaurant | Password Recovery';
    this.email=this.$route.query.email?this.$route.query.email:'';
    console.log(246,this.$route.query.email);
  },  
  computed: {
    stepDetail() {
      const index = this.recoveryStep - 1;
      return this.stepsDetails[index];
    },
  },
  methods: {
    completeProcess() {
      //this.snackbar = true;
      this.$router.push("/auth/login");
    },
  },
};
</script>
